import { generateUuidV4Regex } from "@/common/helpers/utils";
import { Redirect, Route, Switch } from "wouter";
import { CasaviContactWhitelistView } from "./casavi-contact-whitelist.view";
import { CreateView } from "./create/create.view";
import { UpdateView } from "./update/update.view";

export function CasaviContactWhitelistRoutes() {
  const casaviContactWhitelistUuidUpdateRegex = generateUuidV4Regex({
    paramName: "uuid",
    suffix: "/update",
  });

  return (
    <Switch>
      <Route path={casaviContactWhitelistUuidUpdateRegex} component={UpdateView} />
      <Route path={"/"} component={CasaviContactWhitelistView} />
      <Route path={"/create"} component={CreateView} />
      <Redirect to="/" replace />
    </Switch>
  );
}
